import { createEntityUpdater } from '@/helpers/entity-updater';
import { createReducer } from '@ces/sourced-action';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { on } from '@ngrx/store';
import { subscriptionAdded, subscriptionsForAccountLoaded } from '@subscriptions/state/subscription.actions';
import { BTaxAccount } from 'egov-api';
import { addBTaxAccountData } from './btax-account.actions';
import { BTaxAccountEntities } from './btax-account.model';


// Runtime state

const addRuntimeState = (accountData: BTaxAccount): BTaxAccount => ({
    ...accountData
});


// Adapter

const adapter: EntityAdapter<BTaxAccount> = createEntityAdapter<BTaxAccount>({ selectId: a => a.accountNumber });
const updater = createEntityUpdater(adapter, addRuntimeState, 'accountNumber');


// Initial state

const initialState = adapter.getInitialState() as BTaxAccountEntities;


// Reducer

export const btaxAccountsReducer = createReducer<BTaxAccountEntities>(

    initialState,

    on(addBTaxAccountData, (s, { accountsData }) => updater.update(s, accountsData)),

    on(subscriptionsForAccountLoaded, (s, { accountNumber, subscriptionsData }) => adapter.updateOne(
        {
            id: accountNumber,
            changes: { subscriptions: subscriptionsData.map(data => data.id) },
        },
        s
    )),

    on(subscriptionAdded, (s, { accountNumber, subscriptionData }) => adapter.updateOne(
        {
            id: accountNumber,
            changes: { subscriptions: (s.entities[accountNumber]?.subscriptions || []).concat([subscriptionData.id]) }
        },
        s
    )),

);
